import { TConsumerItem } from '../../../types/data';

export const filterBySearch = (search: string, items?: TConsumerItem[], isFiltering = true) => {
    if (items) {
        const result = [];
        for (const item of items) {
            const byAlias = item.alias?.find((a) => a.toLowerCase().indexOf(search.toLowerCase()) >= 0);
            const byTitle = (item.title?.toLowerCase().indexOf(search.toLowerCase()) ?? -1) >= 0;
            if (!isFiltering || byAlias || byTitle) {
                result.push(addMark(item, search));
            }
        }
        return result;
    }
    return [];
};

const addMark = (item: TConsumerItem, search: string): TConsumerItem => {
    const reg = new RegExp(`(${search})`, 'gi');
    const clearTitle = item.title;
    const title = item.title?.replace(reg, `<mark>$1</mark>`);
    return {
        ...item,
        title,
        clearTitle: clearTitle,
    };
};
